/* ------------------------------------------------------------------ */
/*  Image hover-zoom for product gallery – single overlay, no leaks   */
/* ------------------------------------------------------------------ */

const ZOOM_RATIO = 2;       // how much bigger the full-size appears
const OFFSET     = 24;      // px away from the pointer

let currentOverlay = null;  // track the one overlay we allow

/* ---------- helpers ------------------------------------------------ */

function createOverlay(image) {
  const overlay = document.createElement('div');

  overlay.className      = 'image-magnify-full-size';
  overlay.ariaHidden     = 'true';
  overlay.style.position = 'fixed';          // anchored to viewport
  overlay.style.pointerEvents = 'none';      // never blocks the cursor
  overlay.style.backgroundImage = `url('${image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';

  document.body.appendChild(overlay);        // add once, not every move
  return overlay;
}

function moveLens(image, overlay, event) {
  /* background shift inside the lens */
  const ratio     = image.height / image.width;
  const rect      = image.getBoundingClientRect();
  const x         = event.clientX - rect.left;
  const y         = event.clientY - rect.top;
  const xPercent  = `${x / (image.clientWidth  / 100)}%`;
  const yPercent  = `${y / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize     = `${image.width * ZOOM_RATIO}px`;

  /* park the lens next to the cursor */
  overlay.style.left = `${event.clientX + OFFSET}px`;  // viewport X
  overlay.style.top  = `${event.clientY + OFFSET}px`;  // viewport Y
}

/* ---------- core --------------------------------------------------- */

function activateZoom(image, firstEvent) {
  /* clear any previous lens */
  if (currentOverlay) currentOverlay.remove();

  const overlay = createOverlay(image);
  currentOverlay = overlay;

  /* first position immediately – use the real event */
  moveLens(image, overlay, firstEvent);

  /* live follow */
  const follow = (e) => moveLens(image, overlay, e);
  image.addEventListener('mousemove', follow);

  /* cleanup on exit */
  image.addEventListener('mouseleave', () => {
    overlay.remove();
    currentOverlay = null;
    image.removeEventListener('mousemove', follow);
  }, { once: true });
}

/* ---------- bootstrap --------------------------------------------- */

document.querySelectorAll('.image-magnify-hover')
        .forEach(img => img.addEventListener('mouseenter',
          e => activateZoom(img, e)));      // pass the mouseenter event